import React, { useState } from "react";

import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import DataService from "../../services/data.service";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import PaginationStatusBar from "./PaginationStatusBar";
import RefreshStatusBar from "./RefreshStatusBar";

const Flag = () => {
    const { user: currentUser } = useSelector((state) => state.auth);

    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);

    const [rowData, setRowData] = useState([]);

    function onGridReady(params) {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);

        DataService.getFlag()
            .then(res => res.data)
            .then(data => {
                setRowData(data);
            });
    }

    var filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          var dateAsString = cellValue;
          if (dateAsString == null) return -1;
          var dateParts = dateAsString.split('T')[0].split('-');
          var cellDate = new Date(
            Number(dateParts[0]),
            Number(dateParts[1]) - 1,
            Number(dateParts[2])
          );
      
          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0;
          }
      
          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          }
      
          if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          }
          return 0;
        },
        minValidYear: 2000,
        maxValidYear: 2099,
        inRangeFloatingFilterDateFormat: 'DD MMM YYYY',
      };


    return (
        <div style={{ width: "100%", height: "92vh" }}>
            <div
                id="myGrid"
                style={{
                    height: "100%",
                    width: "100%"
                }}
                className="ag-theme-alpine"
            >
                <AgGridReact
                    defaultColDef={{
                        editable: false,
                        enableRowGroup: false,
                        enablePivot: true,
                        enableValue: true,
                        sortable: true,
                        resizable: true,
                        filter: true,
                        flex: 1,
                        minWidth: 100
                    }}
                    suppressRowClickSelection={true}
                    debug={true}
                    rowSelection={"multiple"}
                    pivotPanelShow={"always"}
                    enableRangeSelection={true}
                    pagination={true}
                    onGridReady={onGridReady}
                    rowData={rowData}
                    suppressPaginationPanel={true}
                    frameworkComponents={{
                        RefreshStatusBar,
                        PaginationStatusBar
                    }}
                    statusBar={{
                        statusPanels: [
                            { statusPanel: "RefreshStatusBar", align: "left" },
                            { statusPanel: "agAggregationComponent", align: "left" },
                            { statusPanel: "PaginationStatusBar" }
                        ]
                    }}
                >
                    <AgGridColumn
                        headerName="Date"
                        field="date"
                        filter="agDateColumnFilter"
                        filterParams={filterParams}
                    ></AgGridColumn>
                    <AgGridColumn headerName="Client's tag" field="client"></AgGridColumn>
                    <AgGridColumn headerName="In sum" field="inSum"></AgGridColumn>
                    <AgGridColumn headerName="In count" field="inCount"></AgGridColumn>
                    <AgGridColumn headerName="Out sum" field="outSum"></AgGridColumn>
                    <AgGridColumn headerName="Out count" field="outCount"></AgGridColumn>
                    <AgGridColumn headerName="Sum Difference" field="sumDifference"></AgGridColumn>
                    <AgGridColumn headerName="Count Difference" field="countDifference"></AgGridColumn>
                    <AgGridColumn headerName="Trnx" field="trnx"></AgGridColumn>
                </AgGridReact>
            </div>
        </div>
    );
};

export default Flag;
